<script>
  import Hero from '../parts/hero.svelte'
  import Contact from '../parts/contact.svelte'
  import Footer from '../parts/footer.svelte'
  import Nav from '../parts/nav.svelte'

  export let title
</script>

<svelte:head>
  <title>
    {title} - Devanga Sowdeshwari Amman Association of North America (DSAANA)
  </title>
</svelte:head>

<Hero />

<div class="aboutus-section">
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-sm-6 col-xs-12">
        <div class="aboutus">
          <h2 class="aboutus-title">About Us</h2>
          <p class="aboutus-text">
            Devanga Sowdeshwari Amman Association of North America (DSAANA) is a
            non-profit organization with a mission to build a vibrant Kannada
            Devanga Community and promote rich culture in the North America.
          </p>
          <p class="aboutus-text">
            The main purpose is to meet the community’s growing need for a
            religious, spiritual & cultural center and also to serve the needy
            in the fields of medical relief, education, disaster relief
            services, community services, empowerment of women, youth and
            children, etc.
          </p>
          <a class="aboutus-more" href="/about">read more</a>
        </div>
      </div>

      <div class="col-md-6 col-sm-6 col-xs-12">
        <div class="feature">
          <img width="80%" src="../assets/images/weaving.png" alt="ok" />
        </div>
      </div>
    </div>
  </div>
</div>

<section class="services">
  <div class="head">
    <h2 class="text-center">Our Services</h2>
  </div>
  <div class="in">
    <div class="block">
      <img src="assets/images/services/ser/f.jpg" alt="" />
      <h4>Cultural & Spiritual Empowerment</h4>
    </div>

    <div class="block">
      <img src="assets/images/services/ser/c.jpg" alt="" />
      <h4>Community Outreach</h4>
    </div>

    <div class="block">
      <img src="assets/images/services/ser/r.jpg" alt="" />
      <h4>Fundraising</h4>
    </div>

    <div class="block">
      <img src="assets/images/services/ser/e.jpg" alt="" />
      <h4>Educating / Tutoring</h4>
    </div>

    <div class="block">
      <img src="assets/images/services/ser/w.jpg" alt="" />
      <h4>Women Empowerment</h4>
    </div>

    <div class="block">
      <img src="assets/images/services/ser/y.jpg" alt="" />
      <h4>Youth Empowerment</h4>
    </div>
  </div>

  <div class="bottom d-flex justify-content-center mb-5">
    <a href="/services" class="btn btn-success">Know More</a>
  </div>
</section>

<div class="aboutus-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="aboutus">
          <h2 class="aboutus-title">Our ORIGINS</h2>
          <p class="aboutus-text">
            Devangas are of Brahmanical origin. The majority of them are weavers
            of silk and cotton clothes. There were also famous Devanga kings
            like Boja Raja of Ujjain (Uttar Pradesh, India). Many were also
            warriors during Vijayanagar times, according to warrior stones found
            in Hampi, Karnataka. Their native state was the kingdom of Ujjain
            where even to this day they form the major community.
          </p>
          <p class="aboutus-text">
            &nbsp;&nbsp;&nbsp; Their main deity is Sowdeshwari(Chamundeshwari)
            Amman. As is typical with other castes, Devangas became an
            endogamous unit of weavers, either due to caste rules or due to
            typical social conditions of India.
          </p>
          <a class="aboutus-more" href="/history">read more</a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <Contact /> -->
<Footer />

<style lang="scss">
  .services {
    width: 100%;

    .in {
      width: 90%;
      margin: auto;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;

      @media only screen and (max-width: 1000px) {
        grid-template-columns: 1fr 1fr;
      }

      .block {
        width: 80%;
        margin: 10%;

        img {
          width: 100%;
        }
        h4 {
          text-align: center;
          font-family: 'H1Font';
        }
      }
    }
  }
  .aboutus-section {
    padding: 90px 0;
    border-top: #ff9933 10px solid;
  }
  .aboutus-title {
    font-size: 30px;
    letter-spacing: 0;
    line-height: 32px;
    margin: 0 0 39px;
    padding: 0 0 11px;
    position: relative;
    text-transform: uppercase;
    color: #000;
  }
  .aboutus-title::after {
    background: #fdb801 none repeat scroll 0 0;
    bottom: 0;
    content: '';
    height: 2px;
    left: 0;
    position: absolute;
    width: 54px;
  }
  .aboutus-text {
    // color: #606060;
    // font-size: 13px;
    line-height: 22px;
    margin: 0 0 35px;
  }

  a:hover,
  a:active {
    color: #ffb901;
    text-decoration: none;
    outline: 0;
  }
  .aboutus-more {
    border: 1px solid #fdb801;
    border-radius: 25px;
    color: #fdb801;
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0;
    padding: 7px 20px;
    text-transform: uppercase;
  }
  .feature {
    width: 100%;
  }
  .feature img {
    display: block;
    margin: auto;
  }
</style>
